import React, { useMemo } from "react";

import { useUserStore } from "base/stores";

import styles from "./style.css";

export function AiLoader() {
  const theme = useUserStore((state) => state.theme);
  let userTheme = theme || localStorage.getItem("Theme") || "light";
  const loaderContent = useMemo(
    function themeToFileName() {
      switch (userTheme) {
        case "light":
          return "white_ripple";
        case "dark":
          return "dark_ripple";
        case "dim":
          return "dim_ripple";
        case "system_default":
          return window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark_ripple"
            : "white_ripple";
        default:
      }
    },
    [userTheme]
  );
  return (
    <video
      src={`${window.publicPath}media/videos/case/${loaderContent}.mp4`}
      loop
      autoPlay
      className={styles.video}
    />
  );
}
